module.exports = __webpack_public_path__ + "img/71.162999e5.png";